<template>
  <Dialog title="Edit Organization" :show="isOpen" :onClose="onCancel">
    <el-form
      :model="item"
      label-width="180px"
      label-position="left"
      size="small"
      :rules="rules"
      ref="formRef"
    >
      <el-form-item label="Name" prop="name" required>
        <el-input v-model="item.name" />
      </el-form-item>
      <el-form-item label="Domain" prop="domain" required>
        <el-input v-model="item.domain" />
      </el-form-item>
      <el-form-item label="SAML Metadata IdP file">
        <div class="saml-info">
          <el-input v-model="item.idp_metadata_url" readonly disabled />
          <el-upload
            ref="upload"
            :auto-upload="false"
            accept=".xml"
            :on-change="handleFileChange"
            :file-list="fileList"
            action=""
            list-type="text"
          >
            <el-button slot="trigger" size="small" type="primary"
              >Pick a file</el-button
            >
            <div slot="tip" class="el-upload__tip">
              A SAML XML file, provided by the IdP
            </div>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="Sign SAML requests">
        <el-switch v-model="item.sign_saml_requests" />
      </el-form-item>
      <el-form-item label="Zero data persistence">
        <el-switch v-model="item.zero_data_persistence" />
      </el-form-item>
      <el-divider></el-divider>
      <el-row type="flex" justify="center">
        <el-button type="primary" size="small" @click="save">Save</el-button>
        <el-button size="small" @click="cancel">Cancel</el-button>
      </el-row>
    </el-form>
  </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog";

export default {
  data() {
    return {
      fileList: [],
      data: null,
      rules: {
        domain: [
          {
            required: true,
            message: "Please input the organization domain",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "Please input the organization name",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isOpen: Boolean,
    onCancel: Function,
    onSave: Function,
  },
  components: {
    Dialog,
  },
  methods: {
    onUploadSuccess(response) {
      this.fileList = [];
      this.item.image_url = response.public_url;
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return;
        }

        if (this.fileList.length) {
          this.item.file = this.fileList[0].raw;
        }

        this.onSave(this.item);
      });
    },
    cancel() {
      this.onCancel();
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append("file", file); // Append the file to FormData
    },
    async uploadSAMLIdpMetadata(file) {
      // Simulate an upload request
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Simulate a successful upload
      this.item.idp_metadata_url = "https://example.com/saml.xml";
      this.$message.success("SAML IdP metadata uploaded successfully");
    },
  },
};
</script>

<style scoped>
.saml-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
